import { useEffect, useRef } from "react";

import Header from "../components/Header";
import InputForm from "../components/InputForm";
import Output from "../components/Output";
import QuickActions from "../components/QuickActions";
import { GameProvider, useGame } from "../game/GameContext";

export default function Play() {
  return (
    <GameProvider>
      <PlayInner />
    </GameProvider>
  );
}

function PlayInner() {
  const {
    status,
    ambientImageUrl,
    registerAmbientEl,
    registerSfxEl,
    registerTurnAudioEl,
  } = useGame();

  const appRef = useRef<HTMLDivElement>(null);

  // Visual viewport handling (mobile keyboard).  When the virtual
  // keyboard opens on mobile, the visual viewport shrinks but the
  // layout viewport stays the same.  Resize #app to match so the input
  // form stays visible above the keyboard.
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const onResize = () => {
      const app = appRef.current;
      if (!app) return;
      app.style.height = vv.height + "px";
      app.style.position = "fixed";
      app.style.top = vv.offsetTop + "px";
      app.style.left = "0";
      app.style.right = "0";
    };

    vv.addEventListener("resize", onResize);
    vv.addEventListener("scroll", onResize);
    onResize();
    return () => {
      vv.removeEventListener("resize", onResize);
      vv.removeEventListener("scroll", onResize);
    };
  }, []);

  return (
    <div className="lucid-play">
      <div
        id="ambient-bg"
        style={
          ambientImageUrl
            ? { backgroundImage: `url('${ambientImageUrl}')`, opacity: 0.3 }
            : { opacity: 0 }
        }
      />
      <div id="app" ref={appRef}>
        <Header />
        <Output />
        <QuickActions />
        <InputForm />
        <div id="status">{status}</div>
      </div>

      <audio id="ambient-audio" loop ref={registerAmbientEl} />
      {/* Issue #372: short SFX clips. Layered over ambient — no ducking. */}
      <audio id="sfx-audio" ref={registerSfxEl} />
      <audio id="turn-audio" ref={registerTurnAudioEl} />
    </div>
  );
}
